import React, {ReactNode} from 'react';
import ExpandableJsonField from '@/components/resolve/ExpandableJsonField';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"

interface ViewJProp {
    request?: object;
    response: object;
    children?: ReactNode;
}

const ViewEJson: React.FC<ViewJProp> = function ViewEJson({request, response, children}) {
    return (
        <div
            className="my-2 bg-white bg-opacity-5 border border-theme-blue border-opacity-20 shadow-md rounded flex px-4 flex-col mb-4">
            <Accordion type="single" collapsible className="w-full" defaultValue={ "item-1"}>
                <AccordionItem value="item-1">
                    <AccordionTrigger>Request</AccordionTrigger>
                    <AccordionContent>
                        <pre className="font-light inverse-bg-black p-4 mt-2">
                            <div className="text-pretty">
                              {JSON.stringify(request, null, 2)}
                            </div>
                        </pre>
                    </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-2">
                    <AccordionTrigger>Response</AccordionTrigger>
                    <AccordionContent>
                        <pre className="font-light inverse-bg-black p-4 mt-2">
                            <div className="text-pretty">
                              {JSON.stringify(response, null, 2)}
                            </div>
                        </pre>
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default ViewEJson;
